import { render, staticRenderFns } from "./EnvSelector.vue?vue&type=template&id=2fb06559&scoped=true&"
import script from "./EnvSelector.vue?vue&type=script&lang=js&"
export * from "./EnvSelector.vue?vue&type=script&lang=js&"
import style0 from "./EnvSelector.vue?vue&type=style&index=0&id=2fb06559&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb06559",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VDialog,VIcon,VList,VListItem,VMenu})
